module.exports = __webpack_public_path__ + "img/howard-pro.aaabdc9a.jpg";